import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
/**
 * KTK-317 — small floating popover anchored at the cursor. Closes on
 * outside click, Escape, or scroll. Items collapse to a thin list of
 * buttons so the menu stays as tall as the row count regardless of
 * surrounding chrome.
 */
export function ChannelContextMenu({ channel, x, y, onClose, onEdit }) {
    const ref = useRef(null);
    // Outside-click / Escape / scroll-away dismissal.
    useEffect(() => {
        const onDocMouseDown = (e) => {
            if (!ref.current)
                return;
            if (ref.current.contains(e.target))
                return;
            onClose();
        };
        const onKey = (e) => {
            if (e.key === "Escape")
                onClose();
        };
        const onScroll = () => onClose();
        document.addEventListener("mousedown", onDocMouseDown);
        document.addEventListener("keydown", onKey);
        window.addEventListener("scroll", onScroll, true);
        return () => {
            document.removeEventListener("mousedown", onDocMouseDown);
            document.removeEventListener("keydown", onKey);
            window.removeEventListener("scroll", onScroll, true);
        };
    }, [onClose]);
    // Keep the menu inside the viewport — if a click near the right or
    // bottom edge would overflow, mirror the anchor in that axis.
    const W = 180;
    const H = 60;
    const left = Math.min(x, window.innerWidth - W - 8);
    const top = Math.min(y, window.innerHeight - H - 8);
    return (_jsxs("div", { ref: ref, style: {
            position: "fixed",
            top,
            left,
            zIndex: 200,
            minWidth: W,
            background: "var(--paper)",
            border: "1px solid var(--hairline)",
            borderRadius: 6,
            boxShadow: "0 8px 28px rgba(0,0,0,0.18)",
            padding: 4,
            fontSize: 13,
            color: "var(--ink)",
        }, children: [_jsxs("div", { style: {
                    padding: "4px 10px 6px",
                    fontFamily: "var(--mono)",
                    fontSize: 10,
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                    color: "var(--ink-3)",
                    borderBottom: "1px solid var(--hairline-2)",
                    marginBottom: 2,
                }, children: ["#", channel.name] }), _jsx(MenuItem, { label: "Edit channel", onClick: () => {
                    onEdit();
                    onClose();
                } })] }));
}
function MenuItem({ label, onClick }) {
    return (_jsx("button", { type: "button", onClick: onClick, style: menuItemStyle, onMouseEnter: (e) => {
            e.currentTarget.style.background = "var(--paper-3)";
        }, onMouseLeave: (e) => {
            e.currentTarget.style.background = "transparent";
        }, children: label }));
}
const menuItemStyle = {
    width: "100%",
    textAlign: "left",
    background: "transparent",
    border: "none",
    borderRadius: 4,
    padding: "6px 10px",
    fontFamily: "inherit",
    fontSize: 13,
    color: "var(--ink-2)",
    cursor: "pointer",
};
//# sourceMappingURL=ChannelContextMenu.js.map